export default __webpack_public_path__ + "static/media/wrong.0568db8b.svg";